// extracted by mini-css-extract-plugin
module.exports = {"container":"Qh","list":"Rh"};